/*
 * Static override of the generated client/src/app/app.routes.ts.
 *
 * Why this exists: the base-library route generator sorts by segment
 * count then alphabetically, which places `path: '**'` second
 * (alphabetically `*` precedes the other letters). Angular matches in
 * source order — a `**` at position 2 shadows every later route — so
 * the wildcard must be moved to the bottom for the NotFound page to
 * behave correctly. We also drop `pathMatch: 'full'` from the wildcard
 * route (Angular's wildcard isn't expected to carry that option).
 *
 * Maintenance note: this file mirrors the generator output, so when
 * pages are added or removed in `design/pages/`, this file must be
 * resynced. Diff the generated `client/src/app/app.routes.ts` against
 * this file after running `ad3 generate` (the generator writes first,
 * then the static copy overwrites). Until the generator special-cases
 * wildcard ordering, this stays.
 */

import { Routes } from "@angular/router";
import { roleGuard } from "./guards/role-guard.guard";

export const routes: Routes = [
  {
    path: "solutions/baw-instance-migration",
    title: "BAW Instance Migration — Apex Process Consultants",
    loadComponent: () =>
      import("./pages/baw-instance-migration/baw-instance-migration.page").then(
        (c) => c.BawInstanceMigrationPage,
      ),
    pathMatch: "full",
  },
  {
    path: "consulting",
    title: "Consulting — Apex Process Consultants",
    loadComponent: () =>
      import("./pages/consulting/consulting.page").then(
        (c) => c.ConsultingPage,
      ),
    pathMatch: "full",
  },
  {
    path: "contact",
    title: "Contact — Apex Process Consultants",
    loadComponent: () =>
      import("./pages/contact-us/contact-us.page").then((c) => c.ContactUsPage),
    pathMatch: "full",
  },
  {
    path: "field-notes",
    children: [
      {
        path: "",
        title: "Field Notes — Apex Process Consultants",
        loadComponent: () =>
          import("./pages/field-notes/field-notes.page").then(
            (c) => c.FieldNotesPage,
          ),
        pathMatch: "full",
      },
      {
        path: "**",
        title: "Field Notes — Apex Process Consultants",
        loadComponent: () =>
          import("./pages/field-notes/field-notes.page").then(
            (c) => c.FieldNotesPage,
          ),
      },
    ],
  },
  {
    path: "login",
    title: "Log In — Apex Process Consultants",
    loadComponent: () =>
      import("./pages/login/login.page").then((c) => c.LoginPage),
    pathMatch: "full",
  },
  {
    path: "not-authorized",
    title: "Not Authorized — Apex Process Consultants",
    loadComponent: () =>
      import("./pages/not-authorized/not-authorized.page").then(
        (c) => c.NotAuthorizedPage,
      ),
    pathMatch: "full",
  },
  {
    path: "platform",
    title: "Platform — Apex Process Consultants",
    loadComponent: () =>
      import("./pages/platform/platform.page").then((c) => c.PlatformPage),
    pathMatch: "full",
  },
  {
    path: "switch-user",
    title: "Switch User — Apex Process Consultants",
    loadComponent: () =>
      import("./pages/switch-user/switch-user.page").then(
        (c) => c.SwitchUserPage,
      ),
    pathMatch: "full",
    canActivate: [roleGuard],
  },
  {
    path: "",
    title: "Apex Process Consultants — Simple software for complicated work.",
    loadComponent: () =>
      import("./pages/home/home.page").then((c) => c.HomePage),
    pathMatch: "full",
  },
  {
    path: "**",
    title: "Page Not Found — Apex Process Consultants",
    loadComponent: () =>
      import("./pages/not-found/not-found.page").then((c) => c.NotFoundPage),
  },
];
